var _g, _path, _path2, _g2, _g3, _g4, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_1831_46085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8498 60.6329C24.2514 56.2313 31.3873 56.2308 35.7883 60.6318C40.1894 65.0329 40.1889 72.1688 35.7873 76.5704L25.8277 86.53C21.4261 90.9316 14.2902 90.9321 9.88914 86.531C5.48813 82.13 5.4886 74.9941 9.8902 70.5925L19.8498 60.6329Z",
    fill: "url(#paint0_linear_1831_46085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8498 60.6329C24.2514 56.2313 31.3873 56.2308 35.7883 60.6318C40.1894 65.0329 40.1889 72.1688 35.7873 76.5704L25.8277 86.53C21.4261 90.9316 14.2902 90.9321 9.88914 86.531C5.48813 82.13 5.4886 74.9941 9.8902 70.5925L19.8498 60.6329Z",
    fill: "url(#paint1_linear_1831_46085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8498 60.6329C24.2514 56.2313 31.3873 56.2308 35.7883 60.6318C40.1894 65.0329 40.1889 72.1688 35.7873 76.5704L25.8277 86.53C21.4261 90.9316 14.2902 90.9321 9.88914 86.531C5.48813 82.13 5.4886 74.9941 9.8902 70.5925L19.8498 60.6329Z",
    fill: "url(#paint2_linear_1831_46085)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8498 60.6329C24.2514 56.2313 31.3873 56.2308 35.7883 60.6318C40.1894 65.0329 40.1889 72.1688 35.7873 76.5704L25.8277 86.53C21.4261 90.9316 14.2902 90.9321 9.88914 86.531C5.48813 82.13 5.4886 74.9941 9.8902 70.5925L19.8498 60.6329Z",
    fill: "url(#paint3_radial_1831_46085)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.282 71.3906C39.366 71.3906 24.843 56.8676 24.843 38.9516C24.843 21.0386 39.366 6.51562 57.282 6.51562C75.195 6.51562 89.718 21.0356 89.718 38.9516C89.718 56.8676 75.198 71.3906 57.282 71.3906ZM57.282 66.1406C53.6877 66.1784 50.1215 65.503 46.7899 64.1537C43.4582 62.8043 40.4272 60.8077 37.8721 58.2794C35.3171 55.751 33.2888 52.7411 31.9045 49.4238C30.5202 46.1065 29.8074 42.5477 29.8074 38.9531C29.8074 35.3586 30.5202 31.7997 31.9045 28.4824C33.2888 25.1651 35.3171 22.1552 37.8721 19.6269C40.4272 17.0985 43.4582 15.1019 46.7899 13.7526C50.1215 12.4032 53.6877 11.7279 57.282 11.7656C64.4431 11.8408 71.2854 14.7384 76.3227 19.8288C81.3599 24.9193 84.1854 31.7916 84.1854 38.9531C84.1854 46.1146 81.3599 52.9869 76.3227 58.0774C71.2854 63.1679 64.4431 66.0654 57.282 66.1406Z",
    fill: "url(#paint4_linear_1831_46085)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1831_46085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2819 70.656C39.7709 70.656 25.5779 56.4631 25.5779 38.952C25.5779 21.441 39.7709 7.24805 57.2819 7.24805C74.7929 7.24805 88.9859 21.444 88.9859 38.952C88.9859 56.4631 74.7899 70.656 57.2819 70.656ZM57.2819 65.526C53.7686 65.5634 50.2827 64.9036 47.0261 63.585C43.7694 62.2663 40.8066 60.315 38.309 57.8438C35.8114 55.3726 33.8286 52.4306 32.4755 49.1882C31.1223 45.9457 30.4255 42.4671 30.4255 38.9535C30.4255 35.44 31.1223 31.9614 32.4755 28.7189C33.8286 25.4765 35.8114 22.5345 38.309 20.0633C40.8066 17.5921 43.7694 15.6408 47.0261 14.3221C50.2827 13.0035 53.7686 12.3437 57.2819 12.381C64.2804 12.4554 70.9671 15.2878 75.8897 20.263C80.8124 25.2382 83.5735 31.9546 83.5735 38.9535C83.5735 45.9525 80.8124 52.6689 75.8897 57.6441C70.9671 62.6193 64.2804 65.4517 57.2819 65.526Z",
    fill: "url(#paint5_linear_1831_46085)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2819 70.656C39.7709 70.656 25.5779 56.4631 25.5779 38.952C25.5779 21.441 39.7709 7.24805 57.2819 7.24805C74.7929 7.24805 88.9859 21.444 88.9859 38.952C88.9859 56.4631 74.7899 70.656 57.2819 70.656ZM57.2819 65.526C53.7686 65.5634 50.2827 64.9036 47.0261 63.585C43.7694 62.2663 40.8066 60.315 38.309 57.8438C35.8114 55.3726 33.8286 52.4306 32.4755 49.1882C31.1223 45.9457 30.4255 42.4671 30.4255 38.9535C30.4255 35.44 31.1223 31.9614 32.4755 28.7189C33.8286 25.4765 35.8114 22.5345 38.309 20.0633C40.8066 17.5921 43.7694 15.6408 47.0261 14.3221C50.2827 13.0035 53.7686 12.3437 57.2819 12.381C64.2804 12.4554 70.9671 15.2878 75.8897 20.263C80.8124 25.2382 83.5735 31.9546 83.5735 38.9535C83.5735 45.9525 80.8124 52.6689 75.8897 57.6441C70.9671 62.6193 64.2804 65.4517 57.2819 65.526Z",
    fill: "url(#paint6_radial_1831_46085)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1831_46085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.282 66.8364C41.8815 66.8364 29.397 54.3519 29.397 38.9514C29.397 23.5509 41.8815 11.0664 57.282 11.0664C72.6825 11.0664 85.167 23.5509 85.167 38.9514C85.167 54.3519 72.6825 66.8364 57.282 66.8364Z",
    fill: "url(#paint7_linear_1831_46085)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_1831_46085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2819 66.1407C42.2659 66.1407 30.0929 53.9678 30.0929 38.9517C30.0929 23.9356 42.2659 11.7627 57.2819 11.7627C72.298 11.7627 84.4709 23.9356 84.4709 38.9517C84.4709 53.9678 72.298 66.1407 57.2819 66.1407Z",
    fill: "#64D0EA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7985 32.1364C75.9275 30.4188 75.9388 26.9012 73.8238 24.2796C71.7087 21.6581 68.2683 20.9253 66.1393 22.6429C64.0103 24.3605 63.999 27.8781 66.114 30.4997C68.2291 33.1213 71.6695 33.8541 73.7985 32.1364Z",
    fill: "url(#paint8_linear_1831_46085)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_1831_46085",
    x: 6.08862,
    y: 57.2061,
    width: 33.0002,
    height: 33.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.239216 0 0 0 0 0.439216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1831_46085"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.490196 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1831_46085",
    result: "effect2_innerShadow_1831_46085"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.27451 0 0 0 0 0.380392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1831_46085",
    result: "effect3_innerShadow_1831_46085"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1831_46085",
    x: 25.4279,
    y: 7.09805,
    width: 63.708,
    height: 63.7082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_1831_46085"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1831_46085",
    x: 29.297,
    y: 10.9664,
    width: 55.97,
    height: 55.9695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_1831_46085"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_1831_46085",
    x: 30.093,
    y: 11.6877,
    width: 54.3779,
    height: 54.9529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.603922 0 0 0 0 0.956863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1831_46085"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.075
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.607843 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1831_46085",
    result: "effect2_innerShadow_1831_46085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1831_46085",
    x1: 20.4353,
    y1: 89.2495,
    x2: 29.3427,
    y2: 61.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0659C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895792"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1831_46085",
    x1: 34.6884,
    y1: 61.7805,
    x2: 25.5689,
    y2: 70.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C3B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#845590",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1831_46085",
    x1: 9.93687,
    y1: 70.1258,
    x2: 21.1862,
    y2: 80.7176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#703D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703D7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1831_46085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0936 60.1411) rotate(132.558) scale(7.00008 16.2686)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F1A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532D64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1831_46085",
    x1: 57.282,
    y1: 6.51562,
    x2: 57.282,
    y2: 71.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#344A7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#785790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#785790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9872A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1831_46085",
    x1: 57.2819,
    y1: 7.24805,
    x2: 57.2819,
    y2: 70.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4D87"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1831_46085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2819 22.218) rotate(-90) scale(15.375 28.5937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#566298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#566298",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1831_46085",
    x1: 29.397,
    y1: 38.9514,
    x2: 29.397,
    y2: 94.7214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1831_46085",
    x1: 66.1393,
    y1: 22.6429,
    x2: 73.7985,
    y2: 32.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#DCDBF2",
    stopOpacity: 0.848
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDBF2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.8450a010bf23abe9339445184ef8172b.svg";
export { ForwardRef as ReactComponent };